import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import { CHANGE_EVENT_TYPE_REQUEST, CHANGE_SPECIES_REQUEST, CLEAR_SURVEY, GET_EVENT_QUESTIONS_REQUEST, GET_EVENT_QUESTIONS_SUCCESS, SAVE_EVENT_REQUEST, SAVE_EVENT_SUCCESS, SET_QUESTION_VALUE_REQUEST, SurveyAction, UPLOAD_FILES_SUCCESS, UPLOAD_FILES_REQUEST, SAVE_EVENT_FAILURE } from "../actions/survey.actions";


export type SurveyState = {
    loading: boolean,
    saving: boolean,
    uploadingFile: boolean,
    speciesId: number,
    survey: DTOS.Survey,
    eventTypeId: number
}

const initialState: SurveyState = {
    loading: false,
    saving: false,
    uploadingFile: false,
    speciesId: undefined,
    survey: undefined,
    eventTypeId: undefined
};

export default function survey(state: SurveyState = initialState, action: SurveyAction) {
    switch (action.type) {
        case CHANGE_EVENT_TYPE_REQUEST:
            return changeEventType(state, action);
        case CHANGE_SPECIES_REQUEST:
            return changeSpecies(state, action);
        case CLEAR_SURVEY:
            return clearSurvey(state);
        case GET_EVENT_QUESTIONS_REQUEST:
            return loadSurvey(state, action);
        case GET_EVENT_QUESTIONS_SUCCESS:
            return loadSurvey(state, action);
        case SAVE_EVENT_REQUEST:
            return savingData(state, true);
        case SAVE_EVENT_SUCCESS:
            return savingData(state, false);
        case SAVE_EVENT_FAILURE:
            return savingData(state, false);
        case SET_QUESTION_VALUE_REQUEST:
            return setQuestionValue(state, action);
        case UPLOAD_FILES_REQUEST:
            return uploadFile(state, true);
        case UPLOAD_FILES_SUCCESS:
            return uploadFilesSuccess(state, action);
    }
    return state;
}

function changeEventType(state: SurveyState, action: SurveyAction): SurveyState {
    const newState = update(state, {
        eventTypeId: { $set: action.eventTypeId }
    });
    return newState;
}

function changeSpecies(state: SurveyState, action: SurveyAction): SurveyState {
    const newState = update(state, {
        speciesId: { $set: action.speciesId }
    });
    return newState;
}

function clearSurvey(state: SurveyState): SurveyState {
    const newState = update(state, {
        survey: { $set: undefined }
    });
    return newState;
}

function getSurveyRequest(state: SurveyState, action: SurveyAction): SurveyState {
    const newState = update(state, {
        loading: { $set: true }
    });
    return newState;
}

function loadSurvey(state: SurveyState, action: SurveyAction): SurveyState {
    const newState = update(state, {
        loading: { $set: false },
        survey: { $set: action.survey }
    });
    return newState;
}

function savingData(state: SurveyState, currentlySaving: boolean): SurveyState {
    const newState = update(state, {
        saving: { $set: currentlySaving }
    });
    return newState;
}

function setQuestionValue(state: SurveyState, action: SurveyAction): SurveyState {
    const newState = update(state, {
        survey: {
            questions: {
                [action.questionIndex]: {
                    value: {
                        $set: action.value
                    }
                }
            }
        }
    });
    return newState
}

function uploadFilesSuccess(state: SurveyState, action: SurveyAction): SurveyState {
    const currentFiles = state.survey.questions[action.questionIndex].value

    const newState = uploadFile(state, false);

    return setQuestionValue(newState, {
        type: action.type,
        questionIndex: action.questionIndex,
        value: (currentFiles ? currentFiles + "," : "").concat(action.fileNames)
    });
}

function uploadFile(state: SurveyState, uploading: boolean) {
    const newState = update(state, {
        uploadingFile: { $set: uploading }
    });
    return newState;
}